import { render, staticRenderFns } from "./OficinaMapModal.vue?vue&type=template&id=fdeee5cc&scoped=true&"
import script from "./OficinaMapModal.vue?vue&type=script&lang=js&"
export * from "./OficinaMapModal.vue?vue&type=script&lang=js&"
import style0 from "./OficinaMapModal.vue?vue&type=style&index=0&id=fdeee5cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeee5cc",
  null
  
)

export default component.exports